import { render, staticRenderFns } from "./ELTable.vue?vue&type=template&id=6f96e0b5"
import script from "./ELTable.vue?vue&type=script&lang=js"
export * from "./ELTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports